import { captureScreenshot } from './utils/captureScreenshot';
import { waitForPageLoad } from './utils/waitForPageLoad';

export const handleCurrentPage = async () => {
  await new Promise((resolve) => setTimeout(resolve, 200));

  try {
    await waitForPageLoad();

    const image = await captureScreenshot();

    let toReturn = {
      screenshot: image,
    };

    return toReturn;
  } catch (error) {
    console.error('Failed to capture screenshot:', error);
    return null;
  }
};

